import { Component } from '@angular/core';
import {OktaAuthService} from '../app.service';
import { ContextService } from '../shared/services/context-service';

@Component({
  selector: 'app-not-assigned',
  templateUrl: './not-assigned.component.html',
  styleUrls: ['./not-assigned.component.scss']
})
export class NotAssignedComponent {

  constructor(
    private auth: OktaAuthService,
    public contextService: ContextService ) {
  }

  logout() {
    this.auth.logout();
  }
}
